function clickDownload(link) {
        window.location.href = link;
    }

    // new WheelCarousel('introduction5-sticky-box', 'introduction5-sticky', 'introduction5-wheel-carousel',0.2)

    new Swiper("#introduction5-swiper", {
        slidesPerView: 'auto',
        spaceBetween: 0,
        touchRatio:1.5,
        slidesOffsetBefore: 4,
        updateOnWindowResize: true,
        centeredSlides : true,
        navigation:{
            prevEl: '#introduction5-swiper-button-prev',
            nextEl: '#introduction5-swiper-button-next',
        },
        pagination: {
            el: ".introduction5-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"><span id="introduction5-pagination-node-' + index + '" class="introduction5-pagination-node"> </span></span>';
            }
        }
    });

    new Swiper("#introduction5-swiper-mobile", {
        slidesPerView: 'auto',
        spaceBetween: 16,
        touchRatio:1.5,
        centeredSlides : true,
        navigation:{
            prevEl: '#introduction5-mobile-swiper-button-prev',
            nextEl: '#introduction5-mobile-swiper-button-next',
        },
        pagination: {
            el: '#introduction5-swiper-pagination-mobile',
            renderBullet: function (index, className) {
                return '<span class="' + className + '"> </span>';
            },
        },
        on: {

        },
    });

    setSwiperContentHeight('introduction-h1-mobile')
    setSwiperContentHeight('introduction-h2-mobile')

    $(window).on('resize', function () {
        setSwiperContentHeight('introduction-h1-mobile')
        setSwiperContentHeight('introduction-h2-mobile')
    })
